import React from 'react';
import PropTypes from 'prop-types';
import {List} from 'immutable';
import track from 'react-tracking';

import {addToast, LoadingSpinner} from '@albert-io/atomic';

import {getClassroomsForTeacherClassroomsDashboardQuery} from 'client/Classrooms/Teacher/ClassroomsList/helpers';

import {invalidatePartialInterest} from 'resources/mandark.resource';

import {getClassroomQuery, getInvitationsQuery, getStudentsQuery} from '../People/people.queries';

import ManageRosterContext from './ManageRoster.context';

import manageRosterModalCollection from './manageRosterModalCollection';

import './manage-roster.scss';

@track({component: 'ManageRoster'})
export default class ManageRoster extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    params: PropTypes.object
  };

  constructor(props) {
    super(props);
    const {classId} = props.params;
    this.state = {
      queries: {
        classroom: getClassroomQuery(classId),
        invitations: getInvitationsQuery(classId),
        students: getStudentsQuery(classId)
      },
      classroom: null,
      invitations: List(),
      isReady: false,
      modalToShow: '',
      students: List(),
      setIsReady: (val) => this.setState({isReady: val}),
      setModalToShow: (val) => this.setState({modalToShow: val})
    };
  }

  componentDidMount() {
    this.bootstrapManageRoster();
  }

  componentDidUpdate(_, prevState) {
    if (prevState.isReady && !this.state.isReady) {
      const {resourcePath} = getClassroomsForTeacherClassroomsDashboardQuery().done();
      invalidatePartialInterest({resourcePath});
      this.bootstrapManageRoster();
    }
  }

  bootstrapManageRoster = async () => {
    const {queries} = this.state;

    const results = {};
    for (const [key, query] of Object.entries(queries)) {
      try {
        // eslint-disable-next-line no-await-in-loop
        results[key] = await query.getResourcePromise();
      } catch (error) {
        addToast({
          title: 'Something went wrong',
          type: 'danger',
          message: 'There was a problem loading your roster. If the problem persists, contact us.'
        });
        query.invalidateInterest();
      }
    }

    this.setState((state) => ({
      ...state,
      ...results,
      isReady: true
    }));
  };

  @track((props, state) => ({
    classroom: state.classroom.getId(),
    content: null,
    event: 'click_out',
    type: 'modal'
  }))
  closeModal = () => {
    this.state.setModalToShow('');
  };

  render() {
    if (!this.state.isReady) {
      return <LoadingSpinner size={2} />;
    }
    const ModalRenderer = manageRosterModalCollection[this.state.modalToShow];
    return (
      <ManageRosterContext.Provider value={this.state}>
        {this.props.children}
        {this.state.modalToShow && <ModalRenderer handleClose={() => this.closeModal()} />}
      </ManageRosterContext.Provider>
    );
  }
}
